import React from 'react';
import Select from '../../../components/ui/Select';
import { cn } from '../../../utils/cn';
import {
  CONTRACT_METHOD_PERSONALIZED,
  CONTRACT_METHOD_STANDARD,
} from '../utils/personalizedTemplate';

const METHOD_OPTIONS = [
  { id: CONTRACT_METHOD_STANDARD, label: 'Sistema' },
  { id: CONTRACT_METHOD_PERSONALIZED, label: 'Meus Templates' },
];

function ModelTypeOption({ active, children, onClick, disabled }) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      aria-pressed={active}
      className={cn(
        'rounded-xl px-2.5 py-1.5 text-xs font-caption transition-smooth',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1',
        disabled && 'opacity-50 pointer-events-none',
        active
          ? 'bg-primary text-primary-foreground font-semibold shadow-soft-sm'
          : 'font-medium text-muted-foreground hover:bg-muted/80 hover:text-foreground'
      )}
    >
      {children}
    </button>
  );
}

const ContractTypeSelector = ({
  contractMethod,
  onContractMethodChange,
  selectedType,
  onTypeChange,
  contractTypes,
  selectedUserTemplateId,
  onUserTemplateChange,
  userTemplateOptions,
  userTemplatesLoading,
  disabled,
  hideMethodToggle = false,
  hidePersonalizedHint = false,
}) => {
  const isStandard = contractMethod === CONTRACT_METHOD_STANDARD;

  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <h2 className="text-xl md:text-2xl font-bold text-foreground tracking-tight min-w-0">
          {isStandard ? 'Selecionar Tipo de Documento' : 'Selecionar Modelo Personalizado'}
        </h2>

        {!hideMethodToggle && (
          <div
            className="flex shrink-0 flex-col gap-1.5 sm:items-end"
            role="group"
            aria-label="Tipo Modelo"
          >
            <span className="text-xs font-medium text-muted-foreground font-caption">
              Tipo Modelo
            </span>
            <div className="inline-flex items-center gap-0.5 rounded-xl border border-border bg-muted/50 p-0.5">
              {METHOD_OPTIONS.map((option) => (
                <ModelTypeOption
                  key={option.id}
                  active={contractMethod === option.id}
                  disabled={disabled}
                  onClick={() => onContractMethodChange(option.id)}
                >
                  {option.label}
                </ModelTypeOption>
              ))}
            </div>
          </div>
        )}
      </div>

      {!hidePersonalizedHint && (
        <p className="text-sm text-muted-foreground font-body">
          Escolha <span className="font-medium text-foreground">Meus Templates</span>{' '}
          se quiser usar os modelos que você criou.
        </p>
      )}

      {isStandard ? (
        <Select
          label="Tipo de Documento"
          description="Escolha o modelo de documento que deseja gerar"
          placeholder="Selecione um tipo de documento..."
          options={contractTypes}
          value={selectedType}
          onChange={onTypeChange}
          required
          searchable
          disabled={disabled}
        />
      ) : (
        <Select
          label="Modelo personalizado"
          description="Selecione um dos modelos criados por você no editor"
          placeholder={
            userTemplatesLoading
              ? 'Carregando modelos...'
              : 'Selecione um modelo...'
          }
          options={userTemplateOptions}
          value={selectedUserTemplateId}
          onChange={onUserTemplateChange}
          required
          searchable
          loading={userTemplatesLoading}
          disabled={disabled || userTemplatesLoading}
        />
      )}
    </div>
  );
};

export default ContractTypeSelector;
